import React, { Component } from 'react'
import QRCode from 'qrcode.react'
import { brandStyles, clientUrl, logoNode, money, moneyCents, prizePoolMessage } from './V2Helpers'
import V2PoweredBy from './V2PoweredBy'
import V2RefreshStrip from './V2RefreshStrip'

const prizeSizeClass = (value) => {
    const amount = Math.abs(Number(value || 0))
    if (amount >= 1000000) return " v2-prize-pill--xl"
    if (amount >= 100000) return " v2-prize-pill--long"
    return ""
}

class V2PromoPage extends Component {
    render() {
        const { client, event } = this.props
        const brand = brandStyles(client, event)
        const prizePool = Number(event.prizePool || 0)
        const cause = event.cause || (client && client.name) || "your organisation"
        const eventTitle = event.name || event.title || "Community 50-50 Raffle"
        const supportMessage = prizePoolMessage(client, event)
        const eventPath = "/" + clientUrl(client)
        const eventUrl = window.location.origin + eventPath
        const backgroundStyle = {
            backgroundImage: brand.backgroundUrl ? "url(" + brand.backgroundUrl + ")" : undefined,
            "--v2-primary": brand.primaryColor,
            "--v2-secondary": brand.secondaryColor
        }
        const overlayStyle = {
            backgroundColor: brand.overlayColor,
            opacity: Math.max(brand.overlayOpacity, 0.7)
        }

        return (
            <div className="v2-public-page v2-promo-page" style={backgroundStyle}>
                <V2RefreshStrip />
                <div className="v2-public-overlay" style={overlayStyle} />
                <main className="v2-promo-content">
                    <section className="v2-promo-message">
                        {logoNode(client, event, "v2-public-logo")}
                        <h1>{eventTitle}</h1>
                        <div className="v2-live-label"><span /> Live prize pool</div>
                        <div className={`v2-prize-pill${prizeSizeClass(prizePool)}`}>{money(prizePool)}</div>
                        <section className="v2-split-pools">
                            <article className="v2-split-pool v2-split-pool--winner">
                                <span>Winner</span><strong>{moneyCents(prizePool / 2)}</strong>
                            </article>
                            <article className="v2-split-pool v2-split-pool--cause">
                                <span>{cause}</span><strong>{moneyCents(prizePool / 2)}</strong>
                            </article>
                        </section>
                        <p className="v2-support-copy">{supportMessage}</p>
                    </section>
                    <section className="v2-promo-qr-stack">
                        <div className="v2-promo-qr">
                            <QRCode value={eventUrl} size={1024} includeMargin level="H" />
                        </div>
                        <p className="v2-promo-scan-copy">Scan to buy tickets or go to <strong>{eventUrl.replace(/^https?:\/\//, "")}</strong></p>
                        <V2PoweredBy />
                    </section>
                </main>
            </div>
        )
    }
}

export default V2PromoPage
